import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptSubmitReturnForm = (returnReason: string) => {
  return {
    event: GTMEvent.SUBMIT_RETURN_FROM,
    return_reason: returnReason,
  }
}
